module.exports = __webpack_public_path__ + "media/creativeMedia/panel05-5ec60c0e.png";